<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>
            <router-link to="/" class="black">{{ $t('tenantDetails.properties') }}</router-link> /
            <span class="color-main">{{ $t('tenantDetails.tenantDetailsBreadcrumb') }}</span>
          </h6>
          <p class="font13 gray-col">{{ $t('tenantDetails.subtitle') }}</p>
        </div>
        <div class="flex-sm-gap def-wid">
          <router-link
           v-if="ableEdit"
            class="main-btn lg up"
            :to="{ name: 'editTenant', params: { id: route.params.id } }"
          >
            {{ $t('tenantDetails.editTenantData') }}
          </router-link>
          <button
            class="main-btn up lg bg-red"
            type="button"
            @click="confirmRemove = true"
          >
            {{ $t('tenantDetails.deleteTenant') }}
          </button>
        </div>
      </div>

      <div class="card-details-def mb-3">
        <h6 class="color-main mb-4">{{ $t('tenantDetails.tenantData') }}</h6>
        <div class="flex-bet-main">
          <div class="flex-sm-gap mb-3">
            <img :src="user_image" class="img-user" alt="" />
            <div class="user-data-card">
              <div class="color-main mb-2">
                {{ name }} <span class="gray-col">({{ city.name }})</span>
              </div>
              <div class="flex-sm-gap">
                <a
                  :href="'tel:' + phone"
                  target="_blank"
                  class="phone-info black"
                >
                  <div class="phone-icon">
                    <i class="fa-solid fa-phone"></i>
                  </div>
                  {{ phone }}
                </a>
                <a :href="'mailto:' + email" class="phone-info black">
                  <div class="phone-icon">
                    <i class="fa-solid fa-envelope"></i>
                  </div>
                  {{ email }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-details-def mb-3">
        <h6 class="color-main mb-4">{{ $t('tenantDetails.rentalDetails') }}</h6>
        <div class="row">
          <div class="col-6 mb-4">
            <div class="tenant-info-details">
              {{ $t('tenantDetails.rentValue') }} : <span class="color-main">{{ value }} {{ $t('tenantDetails.currency') }}</span>
            </div>
          </div>
          <div class="col-6 mb-4">
            <div class="tenant-info-details">
              {{ $t('tenantDetails.rentalSystem') }} : <span class="color-main">{{ mode }} يوم</span>
            </div>
          </div>
          <div class="col-6 mb-4">
            <div class="tenant-info-details">
              {{ $t('tenantDetails.rentStart') }} : <span class="color-main">{{ start }}</span>
            </div>
          </div>
          <div class="col-6 mb-4">
            <div class="tenant-info-details">
              {{ $t('tenantDetails.rentEnd') }} : <span class="color-main">{{ end }}</span>
            </div>
          </div>
          <div class="col-6 mb-4">
            <div class="tenant-info-details">
              {{ $t('tenantDetails.electricInvoiceNumber') }} :
              <span class="color-main">{{ eleNumber }}</span>
            </div>
          </div>
          <div class="col-6 mb-4">
            <div class="tenant-info-details">
              {{ $t('tenantDetails.apartmentNumberField') }} : <span class="color-main">{{ departmentNumber }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="card-details-def mb-3">
        <div class="flex-bet-file">
          <div class="flex-sm-gap">
            <div class="file-cont">
              <img :src="fileImg" class="fileImg" alt="" />
            </div>
            <div>{{ $t('tenantDetails.managementContract') }}</div>
          </div>
          <a :href="contract" download target="_blank" class="downloadlink"
            >{{ $t('tenantDetails.downloadContract') }}</a
          >
        </div>
      </div>
      <tenantTabs :Rents="entitlements" />
    </div>
  </main>

  <!-- confirm modal  -->
  <Dialog v-model:visible="confirmRemove" modal :style="{ width: '520px' }">
    <div class="modal-body-main modal-pad">
      <div class="flex-group-me mb-4 mt-3">
        <img :src="dangerImg" class="successImg" alt="" />
      </div>
      <h6 class="font-bold text-center black font17 mb-4">
        {{ $t('tenantDetails.confirmDelete') }}
      </h6>
      <div class="flex-group-me mb-3">
        <button
          type="button"
          @click="removeTenant"
          :disabled="disabled"
          class="main-btn lg up bg-red"
        >
          <div v-if="!disabled">{{ $t('tenantDetails.yesDelete') }}</div>
          <div class="loading" role="status" v-if="disabled">
            {{ $t('tenantDetails.deleting') }}
            <div class="spinner-small-white" v-if="disabled"></div>
          </div>
        </button>
        <button
          type="button"
          class="main-btn lg up bg-trans"
          @click="confirmRemove = false"
        >
          {{ $t('tenantDetails.cancel') }}
        </button>
      </div>
    </div>
  </Dialog>
  <!-- success modal  -->
  <Dialog v-model:visible="suceessRemove" modal :style="{ width: '520px' }">
    <div class="modal-body-main modal-pad">
      <div class="flex-group-me mb-4 mt-3">
        <img :src="successImg" class="successImg" alt="" />
      </div>
      <h6 class="font-bold text-center black font17 mb-4">
        {{ $t('tenantDetails.tenantDeletedSuccess') }}
      </h6>
      <div class="flex-group-me mb-3">
        <router-link
          :to="{ name: 'tenantsView', params: { id: building_number } }"
          class="main-btn lg up"
          >{{ $t('tenantDetails.tenantsLink') }}</router-link
        >
        <router-link to="/dashboardHome" class="main-btn lg up bg-trans"
          >{{ $t('tenantDetails.homeLink') }}</router-link
        >
      </div>
    </div>
  </Dialog>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";
import tenantTabs from "../components/dashboard/tenantTabs.vue";
import Dialog from "primevue/dialog";
const route = useRoute();
import { useRoute } from "vue-router";
import axios from "axios";
import { ref, onMounted } from "vue";
const router = useRouter();
import { useRouter } from "vue-router";
const toast = useToast();
import { useToast } from "primevue/usetoast";

// reactive state
const fileImg = ref(require("../assets/imgs/pdf.png"));
const successImg = ref(require("../assets/imgs/check.png"));
const dangerImg = ref(require("../assets/imgs/noun_warning.png"));
const suceessRemove = ref(false);
const confirmRemove = ref(false);
const disabled = ref(false);

//  refs details
const name = ref("");
const city = ref("");
const phone = ref("");
const email = ref("");
const user_image = ref("");
const value = ref("");
const mode = ref("");
const start = ref("");
const end = ref("");
const eleNumber = ref("");
const departmentNumber = ref("");
const contract = ref("");
const building_number = ref(null);
const ableEdit = ref(true);
const entitlements = ref([]);
// functions
function getTenant() {
  axios
    .get(`/manager/rental-details/${route.params.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      console.log(response.data);
      name.value = response.data.data.rental.user_name;
      city.value = response.data.data.rental.user_city;
      phone.value = response.data.data.rental.user_phone;
      email.value = response.data.data.rental.user_email;
      user_image.value = response.data.data.rental.user_image;
      value.value = response.data.data.rental.price;
      mode.value = response.data.data.rental.period?.period;
      start.value = response.data.data.rental.start;
      end.value = response.data.data.rental.end;
      eleNumber.value = response.data.data.rental.electric_invoice;
      departmentNumber.value = response.data.data.rental.flat_number;
      contract.value = response.data.data.rental.contract;
      building_number.value = response.data.data.rental.building_number;
      ableEdit.value = response.data.data.rental.editable;

      // entitlements
      entitlements.value = response.data.data.entitlements;
    });
}

function removeTenant() {
  disabled.value = true;
  // const fd = new FormData();

  axios
    .delete(`manager/delete-rental/${route.params.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        suceessRemove.value = true;
        confirmRemove.value = false;
        setTimeout(function () {
          router.push(`/tenantsView/${building_number.value}`);
        }, 1500);
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}

// lifecycle hooks
onMounted(() => {
  getTenant();
});
</script>
